<template>
  <div class="img_center">
    
    <!-- Anstatt :id nutzen wir ref="mainSplide" -->
    <section ref="mainSplide" class="splide">
      <div class="splide__track">
        <ul class="splide__list">
          <!-- Erstes Bild -->
          <li class="splide__slide">
            <a :href="product.amazon_url" target="_blank">
              <!-- 'this.' ist im Template nicht nötig -->
              <img :src="product.bild_url" alt="Product Image" />
            </a>
          </li>
          <!-- Weitere Bilder -->
          <li v-for="(imageUrl, index) in imageUrls" :key="index" class="splide__slide">
            <a :href="product.amazon_url" target="_blank">
              <img :src="imageUrl" alt="Product Image" />
            </a>
          </li>
        </ul>
      </div>
    </section>

    <!-- Anstatt :id nutzen wir ref="thumbnailSplide" -->
    <section ref="thumbnailSplide" class="splide">
      <div class="splide__track">
        <ul class="splide__list">
          <li class="splide__slide">
            <img :src="product.bild_url" alt="Product Image" />
          </li>
          <li v-for="(imageUrl, index) in imageUrls" :key="index" class="splide__slide">
            <img :src="imageUrl" alt="Product Image" />
          </li>
        </ul>
      </div>
    </section>
    
  </div>
</template>

<script>
export default {
  props: ['product'],
  
  // Vue Tipp: Computed Properties sind besser als Methods für v-for, 
  // da sie gecached werden und nicht bei jedem kleinen Rerender neu ausrechnen.
  computed: {
    imageUrls() {
      if (!this.product || !this.product.picVariants) return [];
      return this.product.picVariants.split(';');
    }
  },
  
  mounted() {
    // Hier greifen wir nun über this.$refs auf das lokale DOM-Element zu!
    // Völlig unabhängig von irgendwelchen IDs.
    const mainSplideElement = this.$refs.mainSplide;
    const thumbnailSplideElement = this.$refs.thumbnailSplide;

    // Splide direkt mit den DOM-Elementen initialisieren
    const mainSplide = new Splide(mainSplideElement, {
      width: '250px',
      height: '200px',
      type: 'fade',
      rewind: true,
      pagination: false,
      arrows: false,
    });

    const thumbnails = new Splide(thumbnailSplideElement, {
      fixedWidth: 48,
      fixedHeight: 40,
      gap: 2,
      rewind: true,
      pagination: false,
      isNavigation: true,
      breakpoints: {
        1920: {
          width: '250px',
          fixedWidth: 48,
          fixedHeight: 40,
          arrows: false,
        },
        2560: {
          width: '300px',
          fixedWidth: 60,
          fixedHeight: 50,
          arrows: false,
        },
      },
    });

    // Synchronisiere die beiden Splide-Instanzen
    mainSplide.sync(thumbnails);

    // Montiere die Splide-Instanzen
    mainSplide.mount();
    thumbnails.mount();
  }
};
</script>

<style>
/* Füge hier zusätzliche Stile für Splide.js hinzu, falls benötigt */
</style>